import { render, staticRenderFns } from "./LowestPriceFlag.vue?vue&type=template&id=58e415cc&scoped=true"
var script = {}
import style0 from "./LowestPriceFlag.vue?vue&type=style&index=0&id=58e415cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e415cc",
  null
  
)

export default component.exports